import { useNavigate } from 'react-router-dom'

import { api } from '../api/client'
import CredentialGroups from '../components/CredentialGroups'
import { GestioneCredenziali } from '../components/GestioneCredenziali'
import { useAsync } from '../hooks/useAsync'
import { t } from '../i18n/lingua'

/**
 * Le credenziali di **discovery**: quelle con cui le sonde interrogano gli
 * apparati e le piattaforme (SNMP, SSH, WinRM, virtualizzazione, cloud…), e i
 * gruppi che le compongono. Le credenziali delle sorgenti interrogate in tempo
 * reale (backup, IPAM, DNS, Wazuh, firewall, ntopng) stanno nel loro modulo,
 * sezione «Connessioni»: l'elenco è in Integrazioni → Sorgenti dati.
 */
export default function Credentials() {
  const nav = useNavigate()
  const credentials = useAsync(() => api.credentials(), [])
  const groups = useAsync(() => api.credentialGroups(), [])

  return (
    <>
      <header className="page__header">
        <div>
          <h1 className="page__title">{t('Credenziali')}</h1>
          <p className="page__subtitle">{t('Configura le credenziali SNMP, SSH e WinRM utilizzate dalle sonde per interrogare gli asset. Associa a ogni rete o zona il relativo gruppo di credenziali e definisci l’ordine di verifica: la sonda le prova in sequenza fino alla prima autenticazione riuscita e il report indica quella utilizzata. Le credenziali delle piattaforme infrastrutturali, come vCenter, NexaVM e OceanStor, sono gestite in questa sezione; quelle dei sistemi interrogati in tempo reale nelle rispettive Connessioni, mentre ntopng è configurato in Integrazioni → Sorgenti dati.')}</p>
        </div>
        <button className="secondary" onClick={() => nav('/integrations')}>
          {t('Sorgenti dati')}
        </button>
      </header>

      <div className="banner banner--info">
        {t('I segreti sono cifrati e non sono mai più visualizzabili. Vengono consegnati a una sonda solo quando le è stato assegnato un job che li utilizza.')}
      </div>
      <p className="muted">
        {t('Le credenziali dei sistemi letti in tempo reale (backup, IPAM, DNS, Wazuh, firewall, ntopng) si gestiscono nel loro modulo, sezione «Connessioni».')}
      </p>

      <GestioneCredenziali
        filtro={(k) => !k.live}
        onChanged={() => {
          credentials.reload()
          groups.reload()
        }}
      />

      {/* I gruppi stanno qui e non nel modulo di discovery: si compongono una
          volta e si usano molte, e comporli mentre si avvia una scansione
          significherebbe rifarli a ogni scansione. */}
      <CredentialGroups
        credentials={credentials.data ?? []}
        groups={groups.data ?? []}
        loading={groups.loading}
        onChanged={() => groups.reload()}
      />
    </>
  )
}
